<template>
        <div>


        <el-table
             style="width: 100%"
            :data="DataArr"
            :height="tConfig.Height"
            :max-height="tConfig.MaxHeight"
            :stripe="tConfig.IsStripe"
            :border="tConfig.IsBorder"

            :size="tConfig.Size"
            :fit="tConfig.IsFit"
            :show-header="tConfig.IsShowHeader"
            :highlight-current-row="tConfig.IsHighlightCurrentRow"
            :current-row-key="tConfig.CurrentRowKey"
            :row-class-name="tConfig.RowClassName"
            :row-style="tConfig.RowStyle"
            :cell-class-name="tConfig.CellClassName"
            :cell-style="tConfig.CellStyle"
            :header-row-class-name="tConfig.HeaderRowClassName"
            :header-row-style="tConfig.HeaderRowStyle"
            :header-cell-class-name="tConfig.HeaderCellClassName"
            :header-cell-style="tConfig.HeaderCellStyle"
            :row-key="tConfig.RowKey"
            :empty-text="tConfig.EmptyText"
            :default-expand-all="tConfig.IsDefaultExpandAll"
            :expand-row-keys="tConfig.ExpandRowKeys"
            :default-sort="tConfig.DefaultSort"
            :tooltip-effect="tConfig.TooltipEffect"
            :show-summary="tConfig.IsShowSummary"
            :sum-text="tConfig.SumText"
            :summary-method="tConfig.SummaryMethod"
            :span-method="tConfig.SpanMethod"

            @select="OnSelect"
            @select-all="OnSelectAll"
            @selection-change="OnSelectionChange"
            @cell-mouse-enter="OnCellMouseEnter"
            @cell-mouse-leave="OnCellMouseLeave"
            @cell-click="OnCellClick"
            @cell-dblclick="OnCellDBlclick"
            @row-click="OnRowClick"
            @row-contextmenu="OnRowContextmenu"
            @row-dblclick="OnRowDBlclick"
            @header-click="OnHeaderClick"
            @sort-change="OnSortChange"
            @filter-change="OnFilterChange"
            @current-change="OnCurrentChange"
            @header-dragend="OnHeaderDragend"
            @expand-change="OnExpandChange"
            ref="eltable"
        >

        <template   v-for="item in tConfig.TableColumns">
      <!-- :fixed="item.Fixed" -->
            <!-- 多选列 -->
            <el-table-column v-if="(item.type=='selection' || item.type=='index' ) &&  (!item.IsNotShow ) "
                :prop="item.field?item.field:null"
                :label="item.nickName"
                :width="item.Width"
                :min-width="item.MinWidth"

                :type="item.type"
                :render-header="item.RenderHeader"
                :sortable="item.Sortable"
                :sort-method="item.SortMethod"
                :sort-by="item.SortBy"
                :resizable="item.IsResizable"
                :formatter="item.Formatter"
                :show-overflow-tooltip="item.IsShowOverflowTooltip"
                :align="item.Align"
                :header-align="item.HeaderAlign"
                :class-name="item.ClassName"
                :label-class-name="item.LabelClassName"
                :selectable="item.Selectable"
                :reserve-selection="item.ReserveSelection"
                :filters="item.Filters"
                :filter-placement="item.FilterPlacement"
                :filter-multiple="item.IsFilterMultiple"
                :filter-method="item.FilterMethod"
                :filtered-value="item.FilteredValue"
                >


            </el-table-column>
 <!-- :fixed="item.Fixed" -->
            <el-table-column v-if=" item.type=='expand' &&  (!item.IsNotShow ) "
                :prop="item.field?item.field:null"
                :label="item.nickName"
                :width="item.Width"
                :min-width="item.MinWidth"
                :type="item.type"
                :render-header="item.RenderHeader"
                :sortable="item.Sortable"
                :sort-method="item.SortMethod"
                :sort-by="item.SortBy"
                :resizable="item.IsResizable"
                :formatter="item.Formatter"
                :show-overflow-tooltip="item.IsShowOverflowTooltip"
                :align="item.Align"
                :header-align="item.HeaderAlign"
                :class-name="item.ClassName"
                :label-class-name="item.LabelClassName"
                :selectable="item.Selectable"
                :reserve-selection="item.ReserveSelection"
                :filters="item.Filters"
                :filter-placement="item.FilterPlacement"
                :filter-multiple="item.IsFilterMultiple"
                :filter-method="item.FilterMethod"
                :filtered-value="item.FilteredValue"
                >
                    <template slot-scope="scope"  v-if="item.type=='expand'">
                        <keep-alive>
                            <component
                            v-bind:is="item.ExpandComponent"
                            :data="scope.row"
                            :item="item"
                            :tableConfig="TableConfig"
                            :dataArr="DataArr"
                            ></component>
                        </keep-alive>
                    </template>

            </el-table-column>


  <!-- :fixed="item.Fixed" -->
            <el-table-column v-if="item.type!='selection' && item.type!='index' && item.type!='expand' &&  (!item.IsNotShow )"

                :prop="item.field?item.field:null"
                :label="item.nickName"
                :width="item.Width"
                :min-width="item.MinWidth"

                :type="item.type"
                :render-header="item.RenderHeader"
                :sortable="item.Sortable"
                :sort-method="item.SortMethod"
                :sort-by="item.SortBy"
                :resizable="item.IsResizable"
                :formatter="item.Formatter"
                :show-overflow-tooltip="item.IsShowOverflowTooltip"
                :align="item.Align"
                :header-align="item.HeaderAlign"
                :class-name="item.ClassName"
                :label-class-name="item.LabelClassName"
                :selectable="item.Selectable"
                :reserve-selection="item.ReserveSelection"
                :filters="item.Filters"
                :filter-placement="item.FilterPlacement"
                :filter-multiple="item.IsFilterMultiple"
                :filter-method="item.FilterMethod"
                :filtered-value="item.FilteredValue"

                >

                <template slot-scope="scope" >

                    <l-table-value v-if="item.type!='Operation'"
                    :data="scope.row"
                    :item="item"
                    :tableConfig="TableConfig"
                    :dataArr="DataArr"
                    >
                    </l-table-value>
                    <l-table-rowbuttons v-else-if="item.type=='Operation' && tConfig.TableIsEdit && tConfig.TableColumns && tConfig.$TableRowButtons"
                        :tableRowButtons="tConfig.$TableRowButtons"
                        :data="scope.row"
                        :index="scope.$index"
                        >
                    </l-table-rowbuttons>

                </template>

            </el-table-column>

        </template>
        <!-- <el-table-column v-if="tConfig.TableIsEdit && tConfig.TableColumns && tConfig.$TableRowButtons"
            :label="gets("$操作")">
            <template slot-scope="scope">
                <p>姓名: {{ scope.row }}</p>
            </template>
         </el-table-column> -->

        </el-table>
    </div>
</template>
<style>

.el-table__row td.is-hidden:last-child,
.el-table__row td.is-left:last-child,
.el-table__row td.is-right:last-child,
.el-table__row td.is-center:last-child{
    border-right:0px;
}

.el-table__fixed-body-wrapper .el-table__body{
 border-right:1px  solid #e6ebf5;
}
.el-table .has-gutter .cell {
  word-break: break-word !important;
}
.el-table th>.cell{
  word-break: break-word !important;
}
</style>
<script>
var isType = false;


import gets from '@/model/language.js'
import {TableConfigGenerate} from '@/config/config.js'

export default {
    props: ['DataArr', 'TableConfig'],
    data() {
        return {
            currentValue: Object,
            IsNUll: (this.DataArr),
            tConfig : TableConfigGenerate(this.TableConfig)
        }
    },

    created () {
          console.log( "----tConfig----")
        console.log( this.tConfig)
        console.log( "----tConfig----")
    },
    watch:{
        TableConfig (){
                this.tConfig = TableConfigGenerate(this.TableConfig)

        }
    },
    computed: {
        show(){
            return this.DataArr;
        },
        Records(){
            return this.DataArr;
        }
    },
    methods: {
        nullFunction (){
            return function(){

            };
        },
        OnSelect(selection,row){
           if(this.TableConfig.OnSelect){
                this.TableConfig.OnSelect(selection,row)
            }
        },
         OnSelectAll(selection){
           if(this.TableConfig.OnSelectAll){
                this.TableConfig.OnSelectAll(selection)
            }
        },

        OnCurrentChange(currentRow,oldCurrentRow){
            if(this.TableConfig.OnCurrentChange){
                this.TableConfig.OnCurrentChange(currentRow,oldCurrentRow)
            }
        },

        OnSelectionChange(selection){
           if(this.TableConfig.OnSelectionChange){
                this.TableConfig.OnSelectionChange(selection)
            }
        },


        OnCellMouseEnter(row, column, cell, event){
           if(this.TableConfig.OnCellMouseEnter){
                this.TableConfig.OnCellMouseEnter(row, column, cell, event)
            }
        },
        OnCellMouseLeave(row, column, cell, event){
           if(this.TableConfig.OnCellMouseLeave){
                this.TableConfig.OnCellMouseLeave(row, column, cell, event)
            }
        },
        OnCellClick(row, column, cell, event){
           if(this.TableConfig.OnCellClick){
                this.TableConfig.OnCellClick(row, column, cell, event)
            }
        },
        OnCellDBlclick(row, column, cell, event){
           if(this.TableConfig.OnCellDBlclick){
                this.TableConfig.OnCellDBlclick(row, column, cell, event)
            }
        },
        OnRowClick(row, event, column){
           if(window.IsShiftKey){
                 this.$refs.eltable.toggleRowSelection(row);
           }
           if(this.TableConfig.OnRowClick){
                this.TableConfig.OnRowClick(row, event, column)
            }
        },
        OnRowContextmenu(row, event){
           if(this.TableConfig.OnRowContextmenu){
                this.TableConfig.OnRowContextmenu(row, event)
            }
        },
        OnRowDBlclick( row, event){
           if(this.TableConfig.OnRowDBlclick){
                this.TableConfig.OnRowDBlclick( row, event)
            }
        },
        OnHeaderClick(column,  event){
           if(this.TableConfig.OnHeaderClick){
                this.TableConfig.OnHeaderClick(column,  event)
            }
        },
        OnSortChange(obj){
           if(this.TableConfig.OnSortChange){
                this.TableConfig.OnSortChange(obj)
            }
        },


        OnFilterChange(Filters){
           if(this.TableConfig.OnFilterChange){
                this.TableConfig.OnFilterChange(Filters)
            }
        },
        OnCurrentChange(currentRow,oldCurrentRow){
           if(this.TableConfig.OnCurrentChange){
                this.TableConfig.OnCurrentChange(currentRow,oldCurrentRow)
            }
        },
        OnHeaderDragend( newWidth, oldWidth, column, event){
           if(this.TableConfig.OnHeaderDragend){
                this.TableConfig.OnHeaderDragend( newWidth, oldWidth, column, event)
            }
        },
        OnExpandChange(row, expandedRows){
           if(this.TableConfig.OnExpandChange){
                this.TableConfig.OnExpandChange(row, expandedRows)
            }
        },
        gets: gets,
        getDataForPath(d, path) {
            var todata = d;
            var ps = path.split('.')
            for (var i of ps) {
                try {
                    todata = todata[i];
                } catch (error) {
                    return '';
                }
            }
            return todata;
        },
        AddString(c,fieldName){
           var ds = (fieldName+"").split(',')
           var str = '';
           for (var index = 0; index < ds.length; index++) {
               var element = ds[index];
                str += this.getDataForPath(c,element)
           }
           return str;
        },
        AddLanguageString(c,fieldName){
           var ds = (fieldName+"").split(',')
           var str = this.getDataForPath(c,ds[0]);
            if(ds.length>0){
                str += "("+  this.getDataForPath(c,ds[1])+")"
            }
           return str;
        },
    }
}

</script>






// WEBPACK FOOTER //
// table_view.vue?7e057c7d